import React from 'react'
import { withRouter } from 'react-router-dom'

import './ContactBubbles.scss'

// store
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as SHARED_ACTION from '@store/shared/actions'

import TOOLS from '@helpers/tools'
import slugify from 'slugify'
import { isEmpty } from 'lodash'

import {
  EmailButton,
  // CallButton,
  SimulatorButton,
  SimulatorButtonSP,
  WhatsAppButtons,
} from './ContactBubbleButtons'

class ContactBubbles extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      name: '',
      modalWhats: undefined,
      modalChat: undefined,
      modalEmail: undefined,
      modalCall: undefined,
      bubblesOpen: false,
    }
    this.el = React.createRef()
  }


  componentDidUpdate(prevProps) {
    let region = this.props.region
    let product = this.props.product

    if (prevProps.product !== product && !!product && product.success) {
      let imovelId = product.imovel.imovelId
      this.props.actions.getRegionBranches(region, imovelId)
    } else if (prevProps.region !== region && !!region) {
      this.props.actions.getRegionBranches(region)
    } else if (!isEmpty(prevProps.product) && isEmpty(this.props.product)) {
      this.props.actions.getRegionBranches(region)
    }

  }

  _onOpenBubblesClickHandler() {
    if (this.state.bubblesOpen) {
      this._openModalHandler('modalChat')
    } else {
      this.setState({ bubblesOpen: true })
    }
  }

  _gaWhatsapp = (element) => {
    const elementText = element._targetInst !== null ? slugify(element.target.innerText, { lower: true }) : 'whatsapp'
    const timeStamp = Date.now()
    let dataLayer = window['dataLayer']
    let page = window.location.pathname.split('/')[1]

    if (isEmpty(page)) {
      page = 'home'
    }

    if (dataLayer) {
      let ecommerce = {}
      if (window.location.href.includes('apartamento/')) {
        const product = this.props.product.imovel
        let nome = slugify(product.Nome, { lower: true }),
          estado = slugify(product.Localizacao.Estado, { lower: true }),
          cidade = slugify(product.Localizacao.Cidade, { lower: true }),
          bairro = slugify(product.Localizacao.Bairro, { lower: true }),
          marca = 'vivaz',
          preco = new Intl.NumberFormat('pt-BR').format(product.PrecoMinimo)
        ecommerce = {
          purchase: {
            actionField: {
              id: `${timeStamp}`,
            },
            products: {
              id: `${product.imovelId}`,
              name: `${nome}`,
              brand: `${marca}`,
              category: `${estado}/${cidade}`,
              variant: `${bairro}/${product.Quartos}/${product.AreaPrivativaM2}`,
              price: `${preco}`,
            },
          },
        }
      } else {
        ecommerce = {
          purchase: {
            actionField: {
              id: `${timeStamp}`,
            },
            products: {
              id: 'na',
              name: 'na',
              brand: 'vivaz',
              category: 'na',
              variant: 'na',
              price: 1,
            },
          },
        }
      }
      dataLayer.push({
        'event': 'purchase',
        'eventCategory': `${page}`,
        'eventAction': `${elementText}:click`,
        'eventLabel': `${elementText}:${timeStamp}`,
        ecommerce,
      })
    }
  }

  _openModalPhoneHandler() {
    if (!(TOOLS.isMobile())) {
      this._openModalHandler('modalCall')
      return 0
    } else {
      return 1
    }
  }

  _openModalHandler(modalName) {
    this._openModal(modalName)
  }

  _openModal(modal, goback = false) {
    this.props.actions.setContactModalsState(this.props.contactModals, modal, true)
    this.props.actions.optionsModals(goback)
  }


  _checkUrl() {
    const currentPath = window.location.pathname
    let pdp = ''

    if (currentPath.includes('/apartamento/')) { // sub-pages only
      pdp = true
    } else {
      pdp = false
    }
    return pdp
  }
  _createWhatsappUrl(event, phone, typeIntegrationLead, idImovel) {
    const { imovel, region } = this.props
    let pdp = this._checkUrl()
    const gaWhatsAppFunction = this._gaWhatsapp
    TOOLS.createWhatsappUrl({
      event,
      imovel,
      region,
      gaWhatsAppFunction,
      phone,
      typeIntegrationLead,
      idImovel,
      pdp,
    })
  }

  render() {
    const REGION_SP_ID = 1
    const REGION_RS_ID = 24
    let { phone } = this.props
    if (!isEmpty(phone)) {
      if (phone.TelefoneVendaContatoMobile !== null) {
        phone.TelefoneVendaContatoMobileH = phone.TelefoneVendaContatoMobile.replace(/-|\s/g, '').replace(/\(|\s/g, '').replace(/\)|\s/g, '')
      }
      if (phone.TelefoneVendaContatoWhatsApp !== null) {
        phone.TelefoneVendaContatoWhatsAppH = phone.TelefoneVendaContatoWhatsApp.replace(/-|\s/g, '').replace(/\(|\s/g, '').replace(/\)|\s/g, '')
      }
    }

    let idImovel = 0

    if (this.props.product.imovel != null) {
      idImovel = this.props.product.imovel.imovelId
    }

    const isSimulatorHomePage = this.props.location.pathname.startsWith('/simulador')

    let hideSimButton = isSimulatorHomePage ?
      true : false

    let simulatorLink = '/simulador'

    let hideWhatsApp = false

    const isProductPage = (
      this.props.location.pathname.includes('apartamento/') ||
      this.props.location.pathname.includes('vendedor/')
    )

    if (isProductPage) {
      if (!!this.props.imovel && !isEmpty(this.props.imovel)) {
        hideWhatsApp = this.props.imovel.RemoverLinkWhatsapp
        const imovelCode = !!this.props.imovel && !!this.props.imovel.imovelId ? this.props.imovel.imovelId : '0'
        const imovelFacilita = !!this.props.imovel && !!this.props.imovel.IdFacilita ? this.props.imovel.IdFacilita : '0'
        simulatorLink = `/simulador/?idimovel=${imovelCode}`
        if (imovelFacilita) {
          simulatorLink += `&idFacilita=${imovelFacilita}`
        }

        hideSimButton = this.props.imovel.RemoverLinkSimulador
      }
    }

    // const textoLigamos = TOOLS.isMobile() ? 'Te Ligamos' : 'Ligamos Para Você'

    if (isSimulatorHomePage) {
      const simulatorHomeQueryString = this.props.location.search
      const simulatorHomeQueryParams = TOOLS.createObjectFromQueryString(simulatorHomeQueryString || '')

      if (
        !!this.props.previousProduct &&
        !isEmpty(this.props.previousProduct) &&
        !!simulatorHomeQueryParams &&
        !isEmpty(simulatorHomeQueryParams) &&
        simulatorHomeQueryParams.idimovel
      ) {
        hideWhatsApp = this.props.previousProduct.RemoverLinkWhatsapp
      }
    }

    return (
      <div className={`contactBubbles withoutLgpd ${+this.props.region === REGION_SP_ID ? 'contactBubbles--sp' : ''} ${hideSimButton ? '' : 'hasSimButton'}`}>

        {+this.props.region === REGION_SP_ID && isProductPage && ( // SP
          <React.Fragment>
            {hideWhatsApp && hideSimButton && (
              <React.Fragment>
                {/* <CallButton onClick={() => this._openModalHandler('modalCall')} label={textoLigamos} /> */}
                <EmailButton onClick={() => this._openModalHandler('modalEmail')} />
              </React.Fragment>
            )}

            {!hideWhatsApp && !hideSimButton && (
              <React.Fragment>
                <SimulatorButtonSP buttonLink={simulatorLink} />
                <WhatsAppButtons
                  onClickModal={() => this._openModalHandler('modalWhats')}
                  onClickLink={event => this._createWhatsappUrl(
                    event,
                    phone.TelefoneVendaContatoWhatsAppH,
                    phone.TipoGuidIntegracao,
                    idImovel
                  )}
                  phone={phone}
                />
              </React.Fragment>
            )}

            {!hideWhatsApp && hideSimButton && (
              <React.Fragment>
                <EmailButton onClick={() => this._openModalHandler('modalEmail')} />
                <WhatsAppButtons
                  onClickModal={() => this._openModalHandler('modalWhats')}
                  onClickLink={event => this._createWhatsappUrl(
                    event,
                    phone.TelefoneVendaContatoWhatsAppH,
                    phone.TipoGuidIntegracao,
                    idImovel
                  )}
                  phone={phone}
                />
              </React.Fragment>
            )}

            {hideWhatsApp && !hideSimButton && (
              <React.Fragment>
                <SimulatorButtonSP buttonLink={simulatorLink} />
                <EmailButton onClick={() => this._openModalHandler('modalEmail')} />
              </React.Fragment>
            )}
          </React.Fragment>
        )}

        {+this.props.region === REGION_SP_ID && !isProductPage && (
          <React.Fragment>
            {!hideSimButton && <SimulatorButtonSP buttonLink={simulatorLink} />}

            {!hideWhatsApp && (
              <WhatsAppButtons
                onClickModal={() => this._openModalHandler('modalWhats')}
                onClickLink={event => this._createWhatsappUrl(
                  event,
                  phone.TelefoneVendaContatoWhatsAppH,
                  phone.TipoGuidIntegracao,
                  idImovel
                )}
                phone={phone}
              />
            )}
          </React.Fragment>
        )}

        {+this.props.region !== REGION_SP_ID && ( // RJ e RS
          <React.Fragment>
            {!hideSimButton && <SimulatorButton buttonLink={simulatorLink} />}

            <div className='floatingContacts'>
              <ul data-ga-name='bubbles-contato'>
                <li>
                  <p className={(this.state.bubblesOpen ? 'active' : 'inactive') + ' bubble-label'}>Atendimento via Chat</p>
                  <button onClick={() => this._onOpenBubblesClickHandler()} className={'contactBubbles_icon chat' + (this.state.bubblesOpen ? 'Big' : 'Small')} data-ga-action> Atendimento Online</button>
                </li>
                <li className={(this.state.bubblesOpen ? 'active' : 'inactive')} >
                  <p className={(this.state.bubblesOpen ? 'active' : 'inactive') + ' bubble-label'}>Informações via e-mail</p>
                  <button onClick={() => this._openModalHandler('modalEmail')} className='contactBubbles_icon mail' data-ga-action> Informações por e-mail</button>
                </li>
                {!hideWhatsApp && !isEmpty(phone) && phone.TelefoneVendaContatoWhatsApp !== null &&
                  <li className={(this.state.bubblesOpen ? 'active' : 'inactive')} >
                    <p className={(this.state.bubblesOpen ? 'active' : 'inactive') + ' bubble-label'}>Atendimento via WhatsApp</p>
                    <button
                      onClick={event => this._createWhatsappUrl(
                        event,
                        phone.TelefoneVendaContatoWhatsAppH,
                        phone.TipoGuidIntegracao,
                        idImovel
                      )}
                      className='button contactBubbles_icon whats'
                      data-ga-action
                    >
                      Informações via Whatsapp
                    </button>
                  </li>
                }
                {!hideWhatsApp && !isEmpty(phone) && phone.TelefoneVendaContatoWhatsApp == null &&
                  <li className={(this.state.bubblesOpen ? 'active' : 'inactive')}>
                    <p className={(this.state.bubblesOpen ? 'active' : 'inactive') + ' bubble-label'}>Atendimento via WhatsApp</p>
                    <button onClick={() => this._openModalHandler('modalWhats')} className='button contactBubbles_icon whats' data-ga-action> Informações via Whatsapp</button>
                  </li>
                }
                {(!(TOOLS.isMobile())) &&
                  // temporário pra vivaz rs
                  +this.props.region === REGION_RS_ID &&
                  // temporário pra vivaz rs
                  <li className={(this.state.bubblesOpen ? 'active' : 'inactive')} >
                    <p className={(this.state.bubblesOpen ? 'active' : 'inactive') + ' bubble-label'}>Ligamos para você</p>
                    <button onClick={() => this._openModalHandler('modalCall')} className='button contactBubbles_icon call' data-ga-action> Ligamos para você</button>
                  </li>
                }
                {(TOOLS.isMobile()) && !isEmpty(phone) && phone.TelefoneVendaContatoMobile !== null &&
                  // temporário pra vivaz rs
                  +this.props.region === REGION_SP_ID &&
                  // temporário pra vivaz rs
                  <li>
                    <p className={(this.state.bubblesOpen ? 'active' : 'inactive') + ' bubble-label'}>Ligação</p>
                    <a href={`tel:+55${phone.TelefoneVendaContatoMobileH}`} className='button contactBubbles_icon call' data-ga-action> Ligamos para você</a>
                  </li>
                }
                {this.state.bubblesOpen &&
                  <li><button onClick={() => this.setState({ bubblesOpen: false })} className='contactBubbles_icon close' data-ga-action>Close</button></li>
                }
              </ul>
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {

  return {
    contactModals: state.shared.contactModals,
    optionsModals: state.shared.optionsModals,
    phone: state.shared.phone,
    product: state.products.product,
    previousProduct: state.products.previousProduct.imovel,
    imovel: state.products.product.imovel,
    region: state.shared.region,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      ...SHARED_ACTION,
    }, dispatch),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContactBubbles))



// WEBPACK FOOTER //
// ./src/components/shared/elements/ContactBubbles/ContactBubbles.js